import SpecificPropertiesPanel from "./SpecificPropertiesPanel"

export default SpecificPropertiesPanel